import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'render',
	standalone: true,
})
export class RenderPipe implements PipeTransform {
	transform<T, R>(rowData: T, renderer: (data: T) => R): R {
		return renderer(rowData);
	}
}
